<template>
  <div class="container-fluid">
    <loader v-if="loader == true"></loader>
    <form role="form" action="" method="post" class="marginTop">
      <div class="row setup-content">
        <div class="col-md-8 col-sm-offset-2">
          <div class="col-md-12">
            <div class="panel panel-default panel_auto">
              <div class="panel-body">
                <h3>Dados do Veículo</h3>
                <hr />
                <h4>
                  Marca: {{ $route.params.marca }} -
                  {{ $route.params.modelo }} Ano: {{ $route.params.ano }}
                </h4>
              </div>
            </div>
            <br />
            <div
              class="panel panel-default panel_auto"
              id="step-1"
              v-if="step == 1"
            >
              <div class="panel-body">
                <div class="form-group">
                  <div v-if="habilitarcamposVeiculos">
                    <fieldset class="scheduler-border">
                      <legend class="scheduler-border">Veículo</legend>
                      <div class="row form-group">
                        <div class="col-md-3">
                          <label for="marcas">Marca</label>
                          <select
                            name="marcas"
                            v-model="veiculo.marca"
                            id="marcas"
                            class="form-control"
                            required
                            @change="getModelos()"
                          >
                            <option
                              v-for="m in marcasVeiculos"
                              :value="m.Value"
                              :key="m.Value"
                            >
                              {{ m.Label }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-5">
                          <label for="veiculo">Veículo</label>
                          <select
                            id="veiculo"
                            v-model="veiculo.modelo"
                            class="form-control"
                            :disabled="veiculo.marca == '' || !veiculo.marca"
                            required
                            @change="getAnosModelo()"
                          >
                            <option
                              v-for="m in modelosVeiculos"
                              :value="m.Value"
                              :key="m.Value"
                            >
                              {{ m.Label }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-2">
                          <label for="modelo">Ano</label>
                          <select
                            id="modelo"
                            v-model="veiculo.ano"
                            class="form-control"
                            :disabled="veiculo.marca == '' || !veiculo.marca"
                            @change="getVeiculo()"
                            required
                          >
                            <option
                              v-for="m in anoModelo"
                              :value="m.Value"
                              :key="m.Value"
                            >
                              {{ m.Label }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-2">
                          <label>Valor Fipe <small>R$</small></label>
                          <input
                            type="text"
                            v-money="money"
                            name="valor_fipe"
                            id="valor_fipe"
                            readonly
                            v-model="proposta.valor_fipe"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div v-if="!habilitarcamposVeiculos">
                    <label class="labeNegrito14">Valor total do veículo</label>
                    <input
                      id="valorVeiculo"
                      name="valorVeiculo"
                      type="text"
                      class="form-control"
                      required="required"
                      v-money="money"
                      v-model="proposta.valordoVeiculo"
                      disabled
                    /><br />
                    <label class="labeNegrito14">Parcelas</label>
                    <select
                      id="parcelas"
                      name="parcelas"
                      v-model="proposta.parcelas"
                      class="form-control"
                    >
                      <option :value="12">12x</option>
                      <option :value="24">24x</option>
                      <option :value="36">36x</option>
                      <option :value="48">48x</option>
                      <option :value="60">60x</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <br />
                    <label class="labeNegrito14">Valor a Financiar</label><br />
                    <input
                      type="text"
                      class="form-control"
                      v-money="money"
                      required="required"
                      v-model="valorProposta"
                      :disabled="proposta.valoraFinanciar != 0 ? false : true"
                    />
                    <span
                      >O valor mínimo de entrada, corresponde a 10% do valor do
                      veículo R$: {{ valorMinProposta }} Reais</span
                    >
                    <br />
                    <span v-if="msg != ''" class="msgAviso">{{ msg }}</span>
                  </div>

                  <button
                    class="btn-primary btn-lg pull-right btn-custom"
                    type="button"
                    :disabled="valorProposta != 0 ? false : true"
                    @click="goNextStep(2, true)"
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row setup-content" id="step-2" v-if="step == 2">
        <div class="col-md-8 col-md-offset-2">
          <div class="col-md-12">
            <div class="panel panel-default panel_auto">
              <div class="panel-body">
                <h3>Dados Pessoais</h3>
                <hr />
                <div class="form-group">
                  <label class="control-label">CPF*</label>
                  <input
                    id="cpf"
                    name="cpf"
                    type="text"
                    class="form-control"
                    required="required"
                    v-mask="['###.###.###-##']"
                    placeholder="000.000.000-00"
                    v-model="proposta.cpfcnpj"
                    v-on:change="consultaProponente()"
                  />
                </div>

                <div class="form-group">
                  <label class="control-label">Nome*</label>
                  <input
                    type="text"
                    class="form-control"
                    id="nome"
                    name="nome"
                    required="required"
                    v-model="proposta.nome"
                    :disabled="campoAtivo"
                  />
                  <span v-if="nomeOK" class="msgAviso">{{
                    aviso.campoNome
                  }}</span>
                </div>
                <div class="form-group">
                  <label>Data Nascimento*</label>
                  <input
                    id="data_nascimento"
                    name="data_nascimento"
                    type="text"
                    class="form-control"
                    required="required"
                    v-model="proposta.data_nascimento"
                    v-mask="['##/##/####']"
                    :disabled="campoAtivo"
                  />
                  <span v-if="dataNascOk" class="msgAviso">{{
                    aviso.campoDataNascimento
                  }}</span>
                </div>
                <div class="form-group">
                  <label>Estado Civil*</label>
                  <select
                    id="estado_civil"
                    name="estado_civil"
                    v-model="proposta.estado_civil"
                    required="required"
                    class="form-control"
                    :disabled="campoAtivo"
                  >
                    <option value="null"></option>
                    <option value="NÃO INFORMADO">NÃO INFORMADO</option>
                    <option value="SOLTEIRO(A)">SOLTEIRO(A)</option>
                    <option value="CASADO(A)">CASADO(A)</option>
                    <option value="SEPARADO(A)">SEPARADO(A)</option>
                    <option value="DIVORCIADO(A)">DIVORCIADO(A)</option>
                    <option value="VIÚVO(A)">VIÚVO(A)</option>
                    <option value="UNIÃO ESTAVEL">UNIÃO ESTÁVEL</option>
                  </select>

                  <span v-if="estadoCivilOK" class="msgAviso">{{
                    aviso.campoEstadoCivil
                  }}</span>
                </div>
                <div class="form-group">
                  <label>Tipo Renda*</label>
                  <select
                    id="tipo_renda"
                    name="tipo_renda"
                    required="required"
                    v-model="proposta.tipo_renda"
                    class="form-control"
                    :disabled="campoAtivo"
                  >
                    <option value="9">AGROPECUÁRIA</option>
                    <option value="3">APOSENTADORIA</option>
                    <option value="1">PRO-LABORE</option>
                    <option value="0">SALÁRIO</option>
                    <option value="8">RENDIMENTO NÃO COMPROVADO</option>
                  </select>
                  <span v-if="tipoRendaOK" class="msgAviso">{{
                    aviso.campoTipoRenda
                  }}</span>
                </div>
                <div class="form-group">
                  <label class="control-label">Estado*</label>
                  <select
                    id="estado_"
                    name="estado_"
                    placeholder="Estado"
                    required="required"
                    v-model="proposta.estado"
                    class="form-control"
                    :disabled="campoEstadoAtivo"
                  >
                    <option value=""></option>
                    <option v-for="e in estados" :value="e.id" :key="e.id">
                      {{ e.nome }}
                    </option>
                  </select>
                  <span v-if="estadoOK" class="msgAviso">{{
                    aviso.campoEstado
                  }}</span>
                </div>
                <div class="form-group">
                  <label class="control-label">Cidade*</label>
                  <select
                    name="cidade_"
                    id="cidade_"
                    placeholder="cidade"
                    v-model="proposta.cidade"
                    class="form-control"
                    required="required"
                    :disabled="municipios.length != 0 ? false : true"
                  >
                    <option value=""></option>
                    <option v-for="c in municipios" :value="c.id" :key="c.id">
                      {{ c.nome }}
                    </option>
                  </select>
                  <span v-if="cidadeOk" class="msgAviso">{{
                    aviso.campoCidade
                  }}</span>
                </div>
                <div class="form-group">
                  <label class="control-label">Email*</label>
                  <input
                    type="email"
                    class="form-control"
                    id="emailProd"
                    name="emailProd"
                    required="required"
                    v-model="proposta.email"
                    :disabled="campoAtivo2"
                    @blur="validateEmail()"
                  />
                  <span v-if="emailOk" class="msgAviso">{{
                    aviso.campoEmail
                  }}</span>
                  <span v-if="!emailValidoOk" class="msgAviso">{{
                    "E-mail Inválido!"
                  }}</span>
                </div>
                <div class="form-group">
                  <label class="control-label">Celular*</label>
                  <input
                    id="Celular"
                    name="Celular"
                    placeholder="(99) 9 9999 9999"
                    v-mask="['(##) # #### ####']"
                    required="required"
                    class="form-control"
                    :disabled="campoAtivo2"
                    v-model="celular"
                  />
                  <span v-if="celularOk" class="msgAviso">{{
                    aviso.campoCelular
                  }}</span>
                </div>
                <div class="form-group">
                  <label>Tempo de emprego</label>
                  <select
                    id="data_inicio_emprego"
                    placeholder="DD/MM/AAAA"
                    required="required"
                    v-model="proposta.data_emprego"
                    name="data_inicio_emprego"
                    class="form-control"
                    :disabled="campoAtivo2"
                  >
                    <option value="1">Menos de 1 ano</option>
                    <option value="2">Mais de 1 ano</option>
                  </select>
                  <br />
                  <span style="text-align: center"
                    >Ao continuar você está ciente de que o Sicoob Crediauc
                    poderá ter acesso e armazenar suas informações aqui
                    preenchidas e que você poderá ser contatado por e-mail,
                    telefone, Whatsapp ou SMS para tratar da oferta, bem como
                    para ser informado sobre produtos e serviços
                    oferecidos.</span
                  >
                  <br /><br />
                  <input
                    class="btn btn-success font-button"
                    type="button"
                    @click="openPoliticaPrivacidade()"
                    value="Acesse a Política de Privacidade"
                  
                  />
                  <label class="checkbox checkbox-custom-alt">
                    <input
                      type="checkbox"
                      id="checkdeConcordo"
                      name="checkdeConcordo"
                      v-model="proposta.deacordo"
                    />
                    <i></i>
                    <strong>Concordo</strong>
                  </label>
                </div>
                <button
                  v-if="proposta.deacordo"
                  class="btn-primary btn-lg pull-right btn-custom"
                  type="button"
                  @click="calcularParcelas()"
                >
                  Ver Resultado
                </button>
                <button
                  style="margin-right: 3%"
                  class="btn-primary btn-lg pull-right btn-custom"
                  type="button"
                  @click="goNextStep(1, true)"
                >
                  Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row setup-content" id="step-3" v-if="step == 3">
        <div class="col-md-8 col-md-offset-2">
          <div class="col-md-12">
            <div class="panel panel-default panel_auto">
              <div class="panel-body">
                <div class="form-group">
                  <h3>Resultado da Simulação</h3>
                  <hr />
                  <div class="col-md-6">
                    <label class="labeNegrito">Situação: </label><br /><br />
                    <label class="status">{{
                      statusSimulacao ? "Pré-Aprovado" : "Pendente de Aprovação"
                    }}</label>
                  </div>
                  <div class="col-md-5">
                    <label class="labeNegrito">Valor da Parcela:</label
                    ><br /><br />
                    <label class="val-parcela"
                      >{{ proposta.parcelas }} x R$:
                      {{ valorCalcParcela }}</label
                    >
                    <select
                      id="parcelas"
                      name="parcelas"
                      class="form-control"
                      v-model="proposta.parcelas"
                      :disabled="alterarParcela"
                      @change="calcularParcelas(false, false)"
                    >
                      <option :value="12">12x</option>
                      <option :value="24">24x</option>
                      <option :value="36">36x</option>
                      <option :value="48">48x</option>
                      <option :value="60">60x</option></select
                    ><br />
                  </div>
                </div>
                <div class="col-md-6 font-text" style="text-align: center">
                  <span
                    >* Valores estimados. Os valores de parcelas e veículos
                    podem sofrer alteração sem aviso prévio. Os valores são
                    simulados com base nas informações e a concessão de
                    crédito/financiamento é condicionada a análise.</span
                  >
                </div>
                <div class="col-md-4" style="margin-top: 5%; margin-left: 3%">
                  <input
                    type="button"
                    id="bntAltParce"
                    name="bntAltParce"
                    class="btn-info btn-lg pull-right btn-custom"
                    value="Alterar Parcela"
                    @click="alterarParc"
                  />
                </div>
                <span class="msgAviso">{{ mensagemValidacao }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <btn-whatsApp :id="propostaID"></btn-whatsApp>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { VMoney } from "v-money";
import { mask } from "vue-the-mask";
import dadosFixosMixin from "./dadosFixos.js";
import btnWhatsAppVue from "./btnWhatsApp.vue";

var moment = require("moment");

export default {
  name: "indexSimulacao",
  mixins: [dadosFixosMixin],
  components: {
    "btn-whatsApp": btnWhatsAppVue,
  },
  data() {
    return {
      loader: false,
      proposta: {
        cidade: null,
        cpfcnpj: null,
        data_emprego: null,
        data_nascimento: null,
        email: "",
        estado: null,
        estado_civil: null,
        nome: "",
        parcelas: null,
        tipo_renda: null,
        valoraFinanciar: null,
        valordoVeiculo: null,
      },
      objeto: {},
      step: 1,
      Celular: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: true,
      },
      alterarParcela: true,
      estados: [],
      municipios: [],
      paId: 1,
      isCooperado: 0,
      campoAtivo: true,
      campoAtivo2: true,
      fipe_id: null,
      tipo_combustivel: "",
      marca: "",
      modelo: "",
      valorCalcParcela: 0,
      statusSimulacao: false,
      valorMinProposta: 0,
      valorMinPropostaAux: 0,
      valorProposta: 0,
      nextTab: true,
      msg: "",
      campoEstadoAtivo: true,
      mensagemValidacao: "",
      nomeOK: false,
      dataNascOk: false,
      estadoCivilOK: false,
      tipoRendaOK: false,
      estadoOK: false,
      cidadeOk: false,
      emailOk: false,
      emailValidoOk: true,
      celularOk: false,
      veiculo: {},
      modelosVeiculos: [],
      anoModelo: [],
      habilitarcamposVeiculos: false,
      percentualEntradaOK: true,
      objetoID: null,
      proponenteID: null,
      propostaID: null,
      celular: "",
    };
  },

  directives: {
    mask,
    money: VMoney,
  },

  mounted() {
    //this.step = 3;
    this.proposta.data_emprego = 2;
    this.proposta.parcelas = 12;
    this.deacordo = false;
    this.proposta.dias_primeira_parcela = 30;

    this.checkToken();
    this.getDataVeiculo();
    setTimeout(() => {
      this.getDadosEstados();
    }, 500);

    setTimeout(() => {
      this.habilitaMarca();
    }, 3000);
  },

  watch: {
    celular() {
      this.celularOk = this.celular != "" ? false : true;
    },
    valorProposta() {
      let $this = this;
      $this.nextTab = true;
      $this.msg = "";
      let valPro = $this.ajustaValor($this.valorProposta) - 0;

      $this.percentualEntradaOK = true;

      let valorMaximoParaFinanciar =
        $this.ajustaValor($this.proposta.valordoVeiculo) -
        $this.ajustaValor($this.valorMinPropostaAux);

      if (valPro > valorMaximoParaFinanciar) {
        $this.percentualEntradaOK = false;
        $this.msg =
          "Valor máximo que pode ser financiado R$: " +
          valorMaximoParaFinanciar.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          });
        +" Reais, considerando valor de entrada";
        $this.nextTab = false;
      }

      let calcValoraFinanciar =
        parseFloat(
          $this.proposta.valordoVeiculo.replace(".", "").replace("R$", "")
        ) -
        parseFloat($this.valorMinProposta.replace(".", "").replace("R$", ""));

      $this.proposta.valoraFinanciar = calcValoraFinanciar.toLocaleString(
        "pt-br",
        {
          style: "currency",
          currency: "BRL",
        }
      );
    },
  },

  methods: {
    openPoliticaPrivacidade() {
      window.open(
        "https://www.sicoob.com.br/documents/20128/1454810/Pol%C3%ADtica+de+Privacidade.pdf/84343556-3e59-ee16-1eec-321a513716f2?t=1623421253674",
        "-blank"
      );
    },
    habilitaMarca() {
      if (!$("#marcas").hasClass("form-control select2-hidden-accessible")) {
        $("#marcas")
          .select2()
          .change(function () {
            $this.veiculo.marca = $(this).val();
            $this.getModelos();
          });
      }
    },

    ajustaValor(valor) {
      valor =
        valor.indexOf(",") > 0 && valor.indexOf(".") > 0
          ? valor.replace(",", ".").replace(".", "").replace("R$", "")
          : valor.replace(",", ".");
      return valor;
    },

    getModelos() {
      var $this = this;
      this.modelosVeiculos = [];
      if (!$("#modelo").hasClass("form-control select2-hidden-accessible")) {
        $("#modelo")
          .select2()
          .change(function () {
            $this.veiculo.ano = $(this).val();
            $this.getVeiculo();
          });

        $("#veiculo")
          .select2()
          .change(function () {
            $this.veiculo.ano = null;
            $this.veiculo.modelo = $(this).val();
            $this.getAnosModelo();
          });
      }

      $this.loader = true;
      $this.$http
        .get("/fipe/modelos/" + 1 + "/" + $this.veiculo.marca)
        .then(function (response) {
          let anos = response.data["Anos"];

          anos.map((ano, index) => {
            if (ano.Label < moment().format("YYYY") - 15) {
              anos.slice(index, 1);
            }
          });

          $this.modelosVeiculos = response.data["Modelos"];
          $this.anoModelo = anos;
          $this.loader = false;
        })
        .catch((error) => {
          $this.loader = false;
          console.log(error);
        });
    },

    getAnosModelo: function () {
      var $this = this;
      if ($this.veiculo.ano) {
        if ($this.veiculo.ano != "") {
          $this.getVeiculo();
        }
      }

      var veiculo = $this.veiculo.modelo;

      $this.anoModelo = [];
      $this.loader = true;

      $this.$http
        .get("/fipe/anomodelo/" + 1 + "/" + $this.veiculo.marca + "/" + veiculo)
        .then(function (response) {
          let anos = response.data;
          let anosModelo = [];

          for (let index = 0; index < anos.length; index++) {
            if (
              parseInt(anos[index].Label) >=
                parseInt(moment().format("YYYY") - 15) ||
              parseInt(anos[index].Label) == 0
            ) {
              anosModelo.push(anos[index]);
            }
          }

          $this.anoModelo = anosModelo;
          $this.loader = false;
        });
    },

    getVeiculo: function () {
      this.objetoS = {};

      var $this = this;
      $this.loader = true;

      if (
        !$this.veiculo.modelo ||
        $this.veiculo.modelo == "" ||
        $this.veiculo.modelo == null
      ) {
        return $this.getModelosAno();
      }

      var veiculo = $this.veiculo.modelo;

      $this.$http
        .get(
          "/fipe/paramsmodelo/" +
            1 +
            "/" +
            $this.veiculo.marca +
            "/" +
            veiculo +
            "/" +
            $this.veiculo.ano
        )
        .then(function (response) {
          $this.objeto.marca = response.data.Marca;
          $this.objeto.valor_fipe = response.data.Valor.replace("R$ ", "");
          $this.valorMinProposta = response.data.ValorEntrada;
          $this.valorMinPropostaAux = response.data.ValorEntrada;
          $this.proposta.valordoVeiculo = $this.objeto.valor_fipe;
          $this.proposta.valoraFinanciar = $this.objeto.valor_fipe;
          $this.proposta.valor_fipe = response.data.Valor.replace("R$ ", "");
          $this.objeto.modelo = response.data.Modelo;
          $this.objeto.fipe_id = response.data.CodigoFipe;
          $this.objeto.tipo_combustivel = response.data.Combustivel;
          $this.loader = false;
        });
    },

    validateEmail() {
      if (this.proposta.email != null) {
        var re = /\S+@\S+\.\S+/;
        this.emailOk = false;
        this.emailValidoOk = re.test(this.proposta.email);
        return re.test(this.proposta.email);
      }
      return true;
    },

    alterarParc() {
      this.alterarParcela = false;
    },

    validaPreenchimentoDeCampos() {
      const $this = this;
      this.nomeOK = $this.proposta.nome == "" ? true : false;
      this.dataNascOk = this.proposta.data_nascimento == null ? true : false;
      this.estadoCivilOK = this.proposta.estado_civil == null ? true : false;
      this.tipoRendaOK = this.proposta.tipo_renda == null ? true : false;
      this.estadoOK = this.proposta.estado == null ? true : false;
      this.cidadeOk = this.proposta.cidade == null ? true : false;
      this.emailOk = this.proposta.email == "" ? true : false;
      this.emailValidoOk = this.validateEmail();
      this.celularOk = this.celular == null ? true : false;

      let DataNasc = $this.$utils.convertDateBrToEua(
        $this.proposta.data_nascimento
      );
      DataNasc = moment(new Date(DataNasc));
      let dtAtual = moment(new Date());

      let idade = dtAtual.diff(DataNasc, "years");

      if (idade < 18) {
        this.$toastr(
          "warning",
          "Você deve ter no mínimo 18 anos para efetuar a simulação!",
          "Atenção!"
        );
        return false;
      }

      if (
        this.celular == null ||
        this.proposta.cidade == null ||
        this.proposta.cpfcnpj == null ||
        this.proposta.data_emprego == null ||
        this.proposta.data_nascimento == null ||
        this.proposta.email == null ||
        this.proposta.estado == null ||
        this.proposta.estado_civil == null ||
        this.proposta.nome == null ||
        this.proposta.parcelas == null ||
        this.proposta.tipo_renda == null ||
        this.proposta.valoraFinanciar == null ||
        this.proposta.valordoVeiculo == null ||
        this.emailValidoOk == false
      ) {
        return false;
      }
      return true;
    },

    goNextStep(paramStep, voltar = false) {
      const $this = this;
      if (paramStep == 2) {
        if ($this.valorMinProposta == "R$ 0,00 ") {
          return this.$toastr(
            "warning",
            "Valor da entrada deve ser maior que zero",
            "Atenção!"
          );
        }
        if ($this.proposta.valoraFinanciar == "R$ 0,00 ") {
          return this.$toastr(
            "warning",
            "Selecione os dados do Veículo",
            "Atenção!"
          );
        }

        if (!$this.percentualEntradaOK) {
          return this.$toastr("warning", $this.msg, "Atenção!");
        }
      }

      if (voltar) $this.step = paramStep;

      if (paramStep == 3) $this.nextTab = $this.validaPreenchimentoDeCampos();

      if (!$this.nextTab) {
        return false;
      } else {
        $this.step = paramStep;
      }
    },

    getDataVeiculo() {
      let $this = this;

      let formData = new FormData();

      formData.append("tipo", 1);
      formData.append("marca", $this.$route.params.marca);
      formData.append("modelo", $this.$route.params.modelo);
      formData.append("ano", $this.$route.params.ano);
      $this.loader = true;
      $this.$http
        .post("/fipe/getDadosVeiculo", formData)
        .then(function (response) {
          if (response.data.status) {
            $this.proposta.valordoVeiculo = response.data.Valor;
            $this.valorMinProposta = response.data.ValorEntrada;
            $this.valorMinPropostaAux = response.data.ValorEntrada;
            $this.objeto.fipe_id = response.data.fipe_id;
            $this.objeto.valor_fipe = response.data.Valor.replace("R$ ", "");
            $this.objeto.tipo_combustivel = response.data.tipo_combustivel;
            $this.objeto.fipe_id = response.data.Valor;
            $this.objeto.marca = response.data.marca;
            $this.objeto.modelo = response.data.modelo;
          } else {
            $this.habilitarcamposVeiculos = true;
            return this.$toastr(
              "warning",
              "Não foi possível Obter dados do Veículo",
              "Atenção!"
            );
          }
          $this.loader = false;
        })
        .catch(function (error) {
          $this.loader = false;
        });
    },

    getDadosEstados() {
      var $this = this;
      if (!$("#estado_").hasClass("form-control select2-hidden-accessible")) {
        $("#estado_")
          .select2({
            placeholder: "Estado",
          })
          .change(function () {
            $this.proposta.estado = $(this).val();
            $this.estadoOK = false;
            $this.getCidades($this.proposta.estado);
          });

        $("#cidade_")
          .select2()
          .change(function () {
            const cidadeId = $(this).val();
            if (cidadeId != null) {
              $this.campoAtivo2 = false;
              $this.cidadeOk = false;
              $this.proposta.cidade = $(this).val();
            }
          });
      }

      $this.estados = $this.$utils.getEstados();
    },

    consultaProponente() {
      var $this = this;

      var cpf = $this.proposta.cpfcnpj;

      cpf = cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "");

      var valido = this.$utils.validaCPF(cpf);

      if (valido == false) {
        return this.$toastr(
          "warning",
          "CPF informado é inválido " + $this.proposta.cpfcnpj + ".",
          "Atenção!"
        );
      }

      $this.isCooperado = 0;
      $this.loader = true;
      $this.$http
        .get("/cpf/" + cpf)
        .then(function (response) {
          $this.getDadosEstados();

          if (response.data.CLIENTE) {
            if (response.data.CLIENTE.DESCNOMECLIENTE) {
              if (response.data.CLIENTE.NUMCONTACORRENTE != null) {
                $this.isCooperado = 1;
                $this.paId = response.data.CLIENTE.IDUNIDADEINST;
                $("#pa_id").attr("disabled", true);
              }

              $("#nome")
                .val(response.data.CLIENTE.DESCNOMECLIENTE)
                .attr("disabled", true);
              $this.proposta.nome = response.data.CLIENTE.DESCNOMECLIENTE;

              if (response.data.CLIENTE.DATANASCIMENTO != null) {
                $this.proposta.data_nascimento = $this.$utils.formatDate(
                  response.data.CLIENTE.DATANASCIMENTO
                );
              }

              if (response.data.CLIENTE.ESTADOCIVIL != null) {
                $("#estado_civil")
                  .val(response.data.CLIENTE.ESTADOCIVIL)
                  .attr("disabled", true);
                $this.proposta.estado_civil = response.data.CLIENTE.ESTADOCIVIL;
              }

              let codigosFonteDeRenda = [0, 1, 3, 8, 9];
              if (
                response.data.CLIENTE.FONTERENDA != null &&
                codigosFonteDeRenda.indexOf(
                  response.data.CLIENTE.FONTERENDA.CODTIPOFONTERENDA
                ) != -1
              ) {
                $("#tipo_renda")
                  .val(response.data.CLIENTE.FONTERENDA.CODTIPOFONTERENDA)
                  .attr("disabled", true);

                $this.proposta.tipo_renda =
                  response.data.CLIENTE.FONTERENDA.CODTIPOFONTERENDA;
              } else {
                $("#tipo_renda").attr("disabled", false);
              }
            }

            setTimeout(function () {
              $this.campoEstadoAtivo = false;
              $this.campoAtivo = true;
            }, 400);
            $this.validaPreenchimentoDeCampos();
          } else {
            $this.campoEstadoAtivo = false;
            $this.campoAtivo2 = false;
            $this.campoAtivo = false;
          }
          $this.loader = false;
        })
        .catch(function (error) {
          $this.loader = false;
        });
    },

    checkToken() {
      let $this = this;
      $this.$http
        .get("/login/checkToken/" + $this.$route.params.token)
        .then(function (response) {
          if (response.data.token) {
            var form = {};

            form.token = response.data.token;

            $this.$http.post("/login", form).then(function (response) {
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("username", response.data.user.razao_social);
              localStorage.setItem("retorno", response.data.user.retorno);
              localStorage.setItem("seguro", response.data.user.seguro);
              localStorage.setItem("feirao", response.data.user.feirao);
            });
          }
        });
    },

    calcularParcelas(verificarAprovaca = true, incluirDadosProponente = true) {
      var $this = this;

      let ret = $this.goNextStep(3);
      if (ret == false) return true;

      $this.loader = true;

      if (!$this.nextTab)
        return this.$toastr("warning", "favor verificar os campos", "Atenção!");
      else {
        $this.proposta.objeto = {};
        $this.proposta.objeto = $this.objeto;
        $this.proposta.cooperado = $this.isCooperado;
        $this.proposta.tipo_proposta_id = 1;
        $this.proposta.valor_fipe = $this.proposta.valordoVeiculo;
        $this.proposta.terceiro = true;
        $this.proposta.objeto.ano = this.habilitarcamposVeiculos
          ? this.veiculo.ano.substr(0, 4)
          : $this.$route.params.ano.substr(0, 4);
        $this.proposta.valor_proposta = $this.valorMinProposta;
        $this.proposta.pa_id = 1;
        $this.proposta.celular = $this.celular;

        if (incluirDadosProponente) {
          $this.$http
            .post("/propostas/simular", $this.proposta)
            .then(function (res) {
              $this.objetoID = res.data.proposta.objeto_id;
              $this.proponenteID = res.data.proposta.proponente_id;
              $this.propostaID = res.data.proposta.data.id;

              if (res.data.status) {
                $this.calc(verificarAprovaca);
              }
            });
        } else {
          $this.calc(verificarAprovaca);
        }
      }
    },

    calc(verificarAprovaca) {
      const $this = this;
      $this.$http
        .post("/propostas/simular/parcela", {
          ano_modelo: $this.proposta.objeto.ano,
          valor_retorno: 0,
          tipo_proposta_id: 1,
          parcelas: $this.proposta.parcelas,
          id: $this.propostaID,
          created_at: "",
          data_primeira_parcela: "",
          valor_proposta: $this.valorProposta,
          valor_alienacao: 400,
          score: 0,
          valor_fipe: $this.proposta.valordoVeiculo,
          percentual_retorno: 0,
          seguro: 0,
          tr: "N",
          objeto_id: $this.objetoID,
          has_gravame: "S",
          categoria_id: 1,
          lojista_id: 0,
          proponente_id: $this.proponenteID,
          proponente_cpf: $this.proposta.cpfcnpj,
          email: $this.proposta.email,
          tipo_renda: $this.proposta.tipo_renda,
          is_cooperado: $this.isCooperado,
          data_nascimento: $this.proposta.data_nascimento,
          cidade_id: $this.proposta.cidade,
          estado_civil: $this.proposta.estado,
          data_emprego: $this.proposta.data_emprego,
          terceiro: true,
          verificarAprovacao: verificarAprovaca,
          status_aprovacao: $this.statusSimulacao,
          dias_primeira_parcela: $this.proposta.dias_primeira_parcela,
        })
        .then(function (response) {
          $this.loader = false;
          $this.valorCalcParcela = response.data.parcela_iof;
          $this.statusSimulacao = response.data.status;
          $this.mensagemValidacao = response.data.msg;
          setTimeout(() => {
            $this.goNextStep(3);
          }, 300);
        })
        .catch(function (error) {
          $this.loader = false;
        });
      $this.loader = true;
    },

    getCidades(estadoId) {
      var $this = this;
      $this.municipios = [];
      $this.$http
        .get("/sistema/estados/" + estadoId + "/cidades")
        .then(function (response) {
          $this.municipios = response.data;
        });
    },
  },
};
</script>
<style>
a {
  cursor: pointer;
}
.panel_auto {
  border-radius: 10px;
  width: 80%;
  margin-left: 15%;
}
.btn-custom {
  border-radius: 50px;
}

.body2 {
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("https://portalsicoobcrediauc.com.br/assets/images/background.jpg") !important;
}

.labeNegrito {
  font-weight: bold;
  font-size: 18px;
}

.labeNegrito14 {
  font-weight: bold;
  font-size: 14px;
}

.status {
  font-weight: bold;
  font-size: 18px;
  color: #00a194;
}

.val-parcela {
  font-weight: bold;
  font-size: 23px;
  color: #00a194;
}

.msgAviso {
  color: red;
}

@media only screen and (max-width: 500px) {
  .font-text {
    font-size: 12px;
  }
  .marginTop {
    margin-top: 18% !important;
  }
  .font-button{
    font-size: 10px;
  }
}

.font-button{
  font-size: 14px;
}

.font-text {
  font-size: 14px;
}

.marginTop {
  margin-top: 4%;
}
</style>



// WEBPACK FOOTER //
// src/views/terceiros/index.vue